module.exports = __webpack_public_path__ + "img/wz4.e5b4651b.png";